import axios from "axios";

// ✅ Sirf .env se URL lega
const API_BASE_URL = process.env.REACT_APP_API_URL;
const BASE_URL = `${API_BASE_URL}Medicine`;

export const uploadPrescriptionApi = async (formData) => {
  try {
    const res = await axios.post(
      `${BASE_URL}/InsertUserPrescription`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log("✅ API SUCCESS RESPONSE:", res.data);
    return res.data;

  } catch (err) {
    console.log("❌ API ERROR FULL:", err);
    console.log("❌ API ERROR RESPONSE:", err?.response);
    console.log("❌ API ERROR DATA:", err?.response?.data);

    throw err;
  }
};